import { Component } from "@angular/core";
import { FeatureFlagsService } from "src/app/services/feature-flag/feature-flag.service";

@Component({
  selector: 'app-membership-options-wrapper',
  template: `
    <app-membership-options-v2 *ngIf="useRebranded"></app-membership-options-v2>
    <app-membership-options *ngIf="!useRebranded"></app-membership-options>
  `
})
export class MembershipOptionsWrapperComponent {
  public useRebranded: boolean;

  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}
